<div class="language-switch-container">
  <div class="content">
    <kion-drop-down
      [title]="activeLang$ | async"
      [showDropDownOnClick]="false"
      [icon]="icon"
      [options]="options$ | async"
      (selected)="selected($event)"
    ></kion-drop-down>
  </div>
</div>
